// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oQ-z","hovered":"pQ-z","hoverImage":"qQ-z","mainImage":"rQ-z","imageNoBackground":"sQ-z","fullSizeImage":"tQ-z"};